import TechWithPurpose from './TechWithPurpose'
export default TechWithPurpose
